import { useMutation } from 'react-query';
import { DeelprojectDto } from '../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../config/SwaggerProductReservationApi';

const createDGManagement = (project: DeelprojectDto) =>
    getProductReservationApi().deelproject.createCreate(project)
        .then((response) => response.data);

const useCreateDGManagement = () => {
    const useCreateDGManagementMutation = useMutation(createDGManagement);

    return useCreateDGManagementMutation;
};

export default useCreateDGManagement;
